module.exports = __webpack_public_path__ + "media/application/images/svgs/align-center-8b7009e2f9a8e34bed65ef0cff21fb1c.svg";